import { invalidateCache } from 'api/urql/helpers/mutation';

export const createMessage = (results, args, cache, info) => {
  // handlers go here
  invalidateCache('latestMessagesByJobBasedOnUser')(
    results,
    args,
    cache,
    info
  );

  invalidateCache('messages')(
    results,
    args,
    cache,
    info
  );
};
